import { Layout } from '@/components/Layout';
import { HeroSection } from '@/components/HeroSection';
import { IMAGES } from '@/assets/images';

export default function Home() {
  return (
    <Layout>
      <div className="w-full">
        {/* 1. Stencil — exactly matches Screenshot3057 */}
        <HeroSection
          title="Perfect Lines, Every Stencil"
          description="Create picture-perfect, professional designs with high-quality stencils, making excellent outcomes easier to create."
          secondaryDescription="Craft sharp, detailed, and professional designs using premium stencils, delivering consistent accurate results."
          image={IMAGES.STENCIL_PRODUCT}
          secondaryImage={IMAGES.TATTOO_INK_1}
          blobColor="#5d8aa8"
          blobStyle="diagonal"
          ctaLink="/products/stencils"
          rating={4.9}
          reviewCount="500+ Customer Rating"
        />

        {/* 2. Cartridges */}
        <HeroSection
          title="CARTRIDGES"
          description="Precision-crafted cartridges designed for smooth ink flow, consistent performance, and hygienic safety."
          secondaryDescription="Ensuring artists achieve flawless, detailed, and professional results every time they pick up the machine."
          image={IMAGES.CARTRIDGE_PRODUCT}
          secondaryImage={IMAGES.CARTRIDGE_1}
          blobColor="linear-gradient(135deg, #1a3a6b 0%, #e05a1a 60%, #000 100%)"
          blobStyle="gradient"
          ctaLink="/products/cartridges"
          rating={4.9}
          reviewCount="500+ Customer Rating"
        />

        {/* 3. Tattoo Ink */}
        <HeroSection
          title="Tattoo Ink"
          accentWord="Ink"
          accentColor="#8b3a1a"
          description="Premium tattoo ink crafted for vivid expression, delivering rich color, smooth flow, and long-lasting results."
          secondaryDescription="Formulated for professional artists who demand excellence in every shade and saturation level."
          image={IMAGES.INK_PRODUCT}
          secondaryImage={IMAGES.TATTOO_INK_3}
          blobColor="#f0e8e0"
          blobStyle="blob"
          ctaLink="/products/ink"
          rating={4.9}
          reviewCount="500+ Customer Rating"
        />

        {/* 4. Aftercare */}
        <HeroSection
          title="Care Beyond Completion"
          description="Protect and maintain your results with proper aftercare, ensuring healthy, long-lasting quality tattoos."
          secondaryDescription="Gentle, effective formulas trusted by professional tattoo artists and clients worldwide."
          image={IMAGES.AFTERCARE_PRODUCT}
          secondaryImage={IMAGES.TATTOO_INK_2}
          blobColor="linear-gradient(135deg, #f7d9c4 0%, #e8c4d8 100%)"
          blobStyle="gradient"
          ctaLink="/products/aftercare"
          rating={4.9}
          reviewCount="500+ Customer Rating"
          isLast={true}
        />
      </div>
    </Layout>
  );
}
